import React from "react";
import PropTypes from 'prop-types';
import "./style.less";
import utils from "../../utils/utils";
import { LazyLoadImage } from "react-lazy-load-image-component";
import axios from "axios/dist/axios.min.js";

class PipelineHotSellRankList extends React.Component {
  constructor(props) {
    super(props);
    this.tagRefs = {};
  }

  state = {
    showTags: {},
    productsList: []
  }

  componentDidMount() {
    this.getRankList();
    this.checkAllTagOverflow();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.productsList !== this.state.productsList) {
      this.checkAllTagOverflow();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timerID);
  }

  checkAllTagOverflow = () => {
    const { productsList } = this.state;
    const showTags = {};
    const componentId = this.props['customAttributes']['data-component-id'];
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    this.timerID = setTimeout(() => {
      productsList.forEach((item, index) => {
        const tagKey = `${componentId}-${item.sort}-${index}`;
        const tag = this.tagRefs[tagKey];
        if (tag) {
          ctx.font = window.getComputedStyle(tag).font;
          const textWidth = ctx.measureText(tag.textContent).width;
          showTags[tagKey] = textWidth <= tag.clientWidth;
        }
      });
      this.setState({ showTags });
    }, 0);
  };


  getDisplayLabel = (item) => {
    if(!item || !Array.isArray(item.label)) return '';
    const priorityList = [
      '365天新低价',
      '低于往年双11价',
      '低于618价',
      '低于',
      '全网低价'
    ];
    let displayLabel = '';
    for (let keyword of priorityList) {
      const match = item.label.find(label => label.includes(keyword));
      if (match) {
        displayLabel = match;
        return displayLabel;
      }
    }
    const validLabels = (item.label || []).filter(label => label.length <= 6);
    if (!displayLabel && validLabels.length > 0) {
      displayLabel = validLabels[0];
    }
    return displayLabel;
  }

  getRankList = () => {
    const productsList = this.props.config.list;
    const skuIds = productsList.map(item => item.skuId ? item.skuId : 0);
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-topapi/legotop/goods-sku',
      method: 'post',
      withCredentials: true,
      data: {
        skuIds,
      }
    }).then(res => {
      if ( res.data.status === 0 ) {
        const list = res.data.data || [];
        list.forEach((item) => {
          const customProduct = productsList.find((product) => product.skuId == item.skuId);
          if (customProduct) {
            item.img = customProduct.img ? customProduct.img : item.img;
            item.auxiliaryLabel = customProduct.auxiliaryLabel;
            item.name = customProduct.title ? customProduct.title : item.name;
            item.sellingPoint = customProduct.sellingPoint;
            item.displayLabel = this.getDisplayLabel(item);
            if (typeof item.saleNum === 'string') {
              if (item.saleNum.includes('w')) {
                item.saleNum = parseFloat(item.saleNum.replace('w', '')) * 10000;
              } else {
                item.saleNum = Number(item.saleNum);
              }
            }
          }
        });
        list.sort((a, b) => b.saleNum - a.saleNum);
        list.forEach((item, index) => {
          item.sort = index + 1;
        });
        this.setState({ productsList: list });
      }
    })
  }

  handleItemClick = (item, index) => {
    if (!item.href) {
      return;
    }
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.href,
        props: this.props,
        index
      })
      return
    }
    const options = {
      link: item.href,
      sort: index
    }
    const convertUrl = utils.convertHref(item.href);
    utils.jumpToUrl(this.props.routeParams,convertUrl, item.href, options, -1, this.props, false)
  }


  render() {
    const {baseConfig} = this.props.config;
    // const productsList = this.props.config.list;
    const {productsList, showTags} = this.state;
    const {tagRefs} = this;
    const topTagImgUrl = {
      1: 'http://static.shihuocdn.cn/admin/files/20250928/49575901a21e04d163b9df063c4ab960.png',
      2: 'http://static.shihuocdn.cn/admin/files/20250928/8abf5c7f0a02fee5892ff85460ca4006.png',
      3: 'http://static.shihuocdn.cn/admin/files/20250928/3b55566fd83f0653c22af57a6ea5ecef.png',
      4: 'http://static.shihuocdn.cn/admin/files/20250928/427b43c3a957de32852c64f7de17a1c8.png',
    }
    const fireImgUrl = {
      1: 'http://static.shihuocdn.cn/admin/files/20250928/de79682fc8e52b1a6a47671f21bc615f.png',
      2: 'http://static.shihuocdn.cn/admin/files/20250928/c3b777328a2f6bafda88de3dd0be83e0.png',
      3: 'http://static.shihuocdn.cn/admin/files/20250928/b3b140d72738f7ad23730f7794eb4d16.png',
      4: 'http://static.shihuocdn.cn/admin/files/20250928/869648906e7bf0790a97c1b706af5810.png',
    }
    const componentId = this.props['customAttributes']['data-component-id'];

    return (
      <div className="pipeline-hotSellRankList" 
        id={componentId}
        {...this.props['customAttributes']}
      >
        {
          <div className='pipeline-hotSellRankList-container'>
            {
              productsList.map((item, index) => {
                const tagKey = `${componentId}-${item.sort}-${index}`;
                return (
                  // 商品卡片
                  <div className={`product-item ${item.sort < 4 ? `rank${item.sort}` : ''}`} key={`item_${index}_${item.sort}`}
                    onClick={this.handleItemClick.bind(this, item, index)}
                  >
                    {/* 商品内容 */}
                    <div className='product-content'>
                      {/* 商品标签 */}
                      <div className="product-rank-tag">
                        <img
                          src={utils.formatImgUrl(
                            item.sort < 4 ? topTagImgUrl[item.sort] : topTagImgUrl[4],
                            baseConfig.webpSupport
                          )}
                          className="icon"
                        />
                        {item.sort >= 4 && <span className="number">{item.sort}</span>}
                      </div>
                      {/* 商品内容左边 */}
                      <div className={`product-left ${item.sort < 4 ? `rank1-3` : ''}`}>
                        {/* 商品图片 */}
                        <div className='product-img'>
                          <LazyLoadImage
                            width="100%"
                            threshold={500}
                            height="100%"
                            src={utils.formatImgUrl(item.img, baseConfig.webpSupport)}
                            effect="opacity"
                          />
                        </div>
                        {/* 商品辅助标签 标签展示不全隐藏标签*/}
                        { item.auxiliaryLabel && showTags[tagKey] !== false && (
                          <div 
                            ref={el => tagRefs[tagKey] = el}
                            className="product-tag"
                          >
                            {item.auxiliaryLabel}
                          </div>
                        )}
                      </div>
                      {/* top3全网热销信息 */}
                      {item.sort < 4 && 
                        <div className='product-hot-selling-top3'>
                          <img src={utils.formatImgUrl(fireImgUrl[item.sort], baseConfig.webpSupport)} className="fire-icon-top3" />
                          <span className={`hot-selling-text-top3 ${item.sort < 4 ? `rank${item.sort}` : ''}`}>全网热销{item.saleNum < 10000 ? item.saleNum : item.saleNum / 10000 + '万+'}件</span>
                        </div>
                      }
                      {/* 商品内容右边 */}
                      <div className='product-right'>
                        <div className="product-right-content">
                        {/* 非top3全网热销 */}
                        {!(item.sort < 4) &&
                          <div className='product-hot-selling'>
                            <img src={utils.formatImgUrl(fireImgUrl[4], baseConfig.webpSupport)} className="fire-icon" />
                            <span className="hot-selling-text">全网热销{item.saleNum < 10000 ? item.saleNum : item.saleNum / 10000 + '万+'}件</span>
                          </div>
                        }
                        {/* 商品标题 */}
                        <div className={`product-title ${item.sort < 4 ? `rank1-3` : ''}`}>{item.name}</div>
                        {/* 商品卖点文案 */}
                        <div className='product-selling-point'>{item.sellingPoint}</div>
                        <div className={`product-price-section ${item.sort < 4 ? `rank1-3` : ''}`}>
                          {/* 商品价格 + 对比价说明 */}
                          <div className='product-price-content'>
                            <div className='product-price'>
                              <div className="char">¥</div>
                              <div className="price">{item.price}</div>
                              <div className="displayLabel">{item.displayLabel}</div>
                            </div>
                          </div>
                          {/* 商品立即抢购按钮 */}
                          <button className="product-btn">
                            立即抢购
                          </button>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
          
        }
      </div>
    );
  }
}

export default PipelineHotSellRankList;


// WEBPACK FOOTER //
// ./components/pipeline-hotSellRankList/index.js